import { z } from 'zod';

export type FeedbackModalPropsMicrocopy = {
  title: string;
  subtitle: string;
  placeholder: string;
  close: string;
  primaryCta: string;
  secondaryCta: string;
  supportTitle: string;
  supportDescription: string;
  feedbackButton: {
    buttonAriaLabel: string;
    closeAriaLabel: string;
  };
  inputTextareaTestId: string;
};

export const MAX_FEEDBACK_CHARS = 3000;

export const feedbackFormSchema = z.object({
  feedback: z.string().min(1).max(MAX_FEEDBACK_CHARS),
});

export type FeedbackModalData = z.infer<typeof feedbackFormSchema>;

export type FeedbackModalPropsActions = {
  onSubmit: (data: FeedbackModalData) => void;
};

export type FeedbackModalProps = FeedbackModalPropsActions & {
  microcopy: FeedbackModalPropsMicrocopy;
  className?: string;
};
